// Who may delete which order, and when.
//
// This decides what the interface offers. It is not the enforcement: the
// desktop backend refuses a protected-status deletion regardless of what the
// screen shows, and the cloud restricts deletion to administrators. Withholding
// the control only avoids offering something that would be refused.
//
// See TCA-26081406, owner decision 3.

// Online these need a re-typed password. Offline they cannot be deleted at all:
// they are the orders most likely to carry proof of delivery, and the desktop
// has no business destroying them during an outage.
export const PROTECTED_DELETE_STATUSES = ['on_route', 'delivered'];

export const isLocalOrder = (order) => order?.desktop_sync?.origin === 'local';

export const isProtectedFromDelete = (order) => (
  !isLocalOrder(order) && PROTECTED_DELETE_STATUSES.includes(order?.status)
);

export const canDeleteOrder = (order, { isAdmin, offline }) => {
  if (!isAdmin) return false;
  if (!offline) return true;
  // A local order never reached the cloud, so deleting it offline is complete
  // in itself and needs no reconciliation.
  if (isLocalOrder(order)) return true;
  return !isProtectedFromDelete(order);
};
